// libraries
import React from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

const Textarea = (props: FieldProps<string, FieldRenderProps<string, HTMLElement>, HTMLInputElement>): JSX.Element => (
  <Field component="textarea" {...props} />
);

export default Textarea;
